module.exports = __webpack_public_path__ + "static/img/not-found-icon.064e1d36.svg";